export default{
	//手机号
	phone(num){
		if ((/^1(3|4|5|6|7|8|9)\d{9}$/.test(num))) {
			return true;
		}
	},
	//校验url必须以http或https开头
	urlHttp(text){
		if ((/http[s]{0,1}:\/\/([\w.]+\/?)\S*/.test(text))) {
			return true;
		}
	}
}






// WEBPACK FOOTER //
// ./src/common/regular.js